import styled from '@emotion/styled'
import { breakpoints, NativeLink, palette, spacing } from 'main/ui'

export const Container = styled.div<{ background?: string }>`
  align-items: center;
  background: ${({ background }) => background || palette.white};
  border-top: 2px ${palette.lightGray} solid;
  border-bottom: 2px rgb(0, 0, 0, 0.1) solid;
  display: flex;
  padding: ${spacing.majorScale(1)}px ${spacing.majorScale(3)}px;

  @media (min-width: ${breakpoints.lg}px) {
    border-bottom: inherit;
    padding: 0 ${spacing.majorScale(3)}px;
    height: 60px;
  }
`

export const SaveSearchLink = styled(NativeLink)`
  margin-left: auto;
  padding: ${spacing.majorScale(1)}px;
`
